module.exports = __webpack_public_path__ + "media/assets/images/met_blinking-0bd5a26a5851f3496a41777e319a6747.gif";